import React from "react";
import { useLocation } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import MarketplaceHome from "./pages/MarketplaceHome";
import CategoryVendorsPage from "./pages/CategoryVendorsPage";
import VendorDetailPage from "./pages/VendorDetailPage";

const MarketplaceRouter: React.FC = () => {
  const { pathname } = useLocation();

  let content: React.ReactNode = <MarketplaceHome />;

  if (pathname.includes("/marketplace/vendor/")) {
    content = <VendorDetailPage />;
  } else if (pathname.includes("/marketplace/category/")) {
    content = <CategoryVendorsPage />;
  }

  return (
    <Grid xs sx={{ flex: 1, minWidth: 0 }}>
      {content}
    </Grid>
  );
};

export default MarketplaceRouter;
